import PropTypes from "prop-types";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function SectionHeading({ title, subtitle, eyebrow, first = false }) {
  return (
    <SoftBox
      mb={{ xs: 3, md: 4 }}
      mt={first ? 0 : { xs: 4, md: 5 }}
      sx={{ maxWidth: "100%" }}
    >
      {eyebrow && (
        <SoftTypography
          variant="caption"
          fontWeight="bold"
          color="info"
          textTransform="uppercase"
          letterSpacing="0.08em"
          display="block"
          mb={1}
        >
          {eyebrow}
        </SoftTypography>
      )}
      <SoftTypography variant="h5" fontWeight="bold" color="dark" sx={{ mb: subtitle ? 1.25 : 0, lineHeight: 1.3 }}>
        {title}
      </SoftTypography>
      {subtitle && (
        <SoftTypography
          variant="body2"
          color="text"
          sx={{ maxWidth: "48rem", lineHeight: 1.65 }}
        >
          {subtitle}
        </SoftTypography>
      )}
    </SoftBox>
  );
}

SectionHeading.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  eyebrow: PropTypes.string,
  first: PropTypes.bool,
};

export default SectionHeading;
